export default __webpack_public_path__ + "static/media/check-button.4388727c.png";